/* global angular */
angular.module('ua5App.index.list')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('index.list', {
                url: 'list',
                templateUrl: 'states/index.list/index.list.html',
                controller: 'ListCtrl',
                controllerAs: 'ctrl'
            })
        ;
    }])
    .run(['$rootScope', '$state', function($rootScope, $state) {
        // Redirect users to artists list when just going to list
        $rootScope.$on('$stateChangeSuccess', function(e, toState) {
            if (toState.url === 'list') {
                $state.go('index.list.artists');
            }
        });
    }])
    .controller('ListCtrl', [
    'posts',
    '$filter',
    '$stateParams',
    function(posts, $filter, $stateParams) {

    }])
;
